// extracted by mini-css-extract-plugin
export default {"wrapper":"aNcaaLqpRg3IIAlUjwMG","breadcrumb":"xHDzen1B5V0387GlY3Ec"};